import { TestimonialsService } from './../services/testimonials.service';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Testimonial } from 'src/libs-common/models/testimonial.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  testimonials: Testimonial[] | null = [];
  subscription1?: Subscription;
  data = {
    title: 'ADIEM | NDIS Plan Managers',
    description:
      'ADIEM Plan Management will help you manage your NDIS budget. We handle all of your provider payments and \
      record-keeping that comes with managing your NDIS plan. We will send you monthly statements to help you stay \
      on top of your funds.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/adiem-prod.appspot.com/o/images%2Fndis-participant-with-support-provider.jpg?alt=media&token=aed358b9-9b3b-422c-8202-116ee21bbf5e'
  };


  constructor(private title: Title, private meta: Meta, private testimonialsService: TestimonialsService) {
    this.subscription1 = this.testimonialsService.testimonials$?.subscribe((testimonials) => {
      this.testimonials = testimonials;
    })
  }

  ngOnInit(): void {

    this.title.setTitle(this.data.title);
    this.meta.addTags([
      { name: 'twitter:card', content: 'summary' },
      { name: 'og:url', content: '/home' },
      { name: 'og:title', content: this.data.title },
      { name: 'og:description', content: this.data.description },
      { name: 'og:image', content: this.data.image }
    ]);
  }
}
